const CODE_SPLITTERS = ['|', '\u001d'];


export function splitItemCode(code: string): string[] {
    let splitted = null;
    CODE_SPLITTERS.some(splitter => {
        if (code.indexOf(splitter) >= 0) {
            splitted = code.split(splitter, 2);
        }
        return splitted ? true : false;
    });
    return splitted;
}

export function arrayMoveItem(target: any[], item: any, newIndex: number): any[] {
    const currentIndex = target.indexOf(item);
    if (currentIndex >= 0 && newIndex < target.length) {
        return arrayMoveIndex(target, currentIndex, newIndex);
    }
}

export function arrayMoveIndex(target: any[], oldIndex: number, newIndex: number): any[] {
    const arr = [...target];
    newIndex = ((newIndex % arr.length) + arr.length) % arr.length;
    arr.splice(newIndex, 0, arr.splice(oldIndex, 1)[0]);
    return arr;
  }